<template>
  <div v-if="cookieData">
    <h1>{{ cookieData.Headline }}</h1>
    <div v-html="cookieData.LongDescription" />
  </div>
</template>

<script>
export default {
  name: 'cookies',
  props: {
    ajaxUrl: {
      type: String,
      required: true
    },
    dataUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      cookieData: null
    };
  },
  methods: {
    emitLogData(page, action) {
      this.$emit(
        'log-it',
        '{"page": "' + page + '", "action": "' + action + '"}'
      );
    }
  },
  created() {
    const url = this.ajaxUrl + 'getData.php?';
    const params = {
      dataUrl: this.dataUrl,
      dataFile: 'cookies_de'
    }
    this.$http.post(url, params, {
      emulateJSON: true
    })
        .then(response => {
          this.cookieData = response.data;
        })
        .catch(() => {})
  },
  mounted() {
    setTimeout(() => {
      this.emitLogData('cookies', 'visit');
    }, 10);
  },
  beforeDestroy() {
    this.emitLogData('cookies', 'leave');
  }
}
</script>
